import styled from 'styled-components'

export const StyledCard = styled.div<{
  $isHovered?: boolean
  $clickable?: boolean
  $isOutOfPlanWindow?: boolean
}>`
  position: relative;
  padding: 12px;
  border: 1px solid
    ${({ theme, $isHovered }) =>
      $isHovered ? theme.colors.primary : '#e6e6e6'};
  border-radius: 6px;
  background-color: ${({ $isOutOfPlanWindow }) =>
    $isOutOfPlanWindow ? '#f5f5f5' : '#ffffff'};
  opacity: ${({ $isOutOfPlanWindow }) => ($isOutOfPlanWindow ? 0.65 : 1)};
  cursor: ${({ $clickable }) => ($clickable ? 'pointer' : 'default')};
  transition: all 200ms ease-out;
  max-width: 100%;
  box-sizing: border-box;

  &:hover {
    ${({ $clickable, $isOutOfPlanWindow, theme }) =>
      $clickable
        ? `
      transform: translateY(-2px);
      box-shadow: 0 4px 12px rgba(0, 0, 0, 0.08);
      border-color: ${theme.colors.primary};
      ${$isOutOfPlanWindow ? 'opacity: 0.85;' : ''}
    `
        : ''}
  }

  &:active {
    ${({ $clickable }) => ($clickable ? 'transform: translateY(0);' : '')}
  }

  /* Mobile: reduce padding */
  @media (max-width: 640px) {
    padding: 12px;
  }

  /* Disable hover transform on touch devices */
  @media (hover: none) {
    &:hover {
      transform: none;
    }
  }
`

export const CardHeader = styled.div`
  display: flex;
  align-items: center;
  gap: 10px;
  margin-bottom: 10px;
`

export const RadarWrapper = styled.div`
  flex-shrink: 0;
`

export const IconWrapper = styled.div`
  width: 48px;
  height: 48px;
  display: flex;
  align-items: center;
  justify-content: center;
  flex-shrink: 0;
`

export const AddressSection = styled.div`
  min-width: 0;
  flex: 1;
`

export const Address = styled.h3`
  font-size: 13px;
  font-weight: 600;
  line-height: 1.3;
  color: #1a1a1a;
  margin: 0 0 2px 0;
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;

  /* Mobile: slightly smaller font */
  @media (max-width: 768px) {
    font-size: 14px;
  }
`

export const Municipality = styled.p`
  font-size: 11px;
  line-height: 1.3;
  color: #666666;
  margin: 0;
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
`

export const MetricsRow = styled.div`
  display: flex;
  gap: 10px;
  margin: 6px 0;
  padding: 6px 0;
  border-top: 1px solid #f5f5f5;
  border-bottom: 1px solid #f5f5f5;

  /* Mobile: reduce gap and consider wrapping if needed */
  @media (max-width: 768px) {
    gap: 8px;
    flex-wrap: wrap;
  }
`

export const Metric = styled.div`
  display: flex;
  align-items: center;
  gap: 5px;
  font-size: 12px;
  color: #404040;
`

export const MetricIcon = styled.div`
  width: 12px;
  height: 12px;
  display: flex;
  align-items: center;
  justify-content: center;
  color: #808080;
`

export const MetricValue = styled.span`
  font-weight: 500;
`

export const CardFooter = styled.div`
  display: flex;
  align-items: center;
  justify-content: space-between;
  margin-top: 6px;
  gap: 6px;
  min-width: 0;
`

export const EgridText = styled.p`
  font-size: 10px;
  line-height: 1.4;
  color: #808080;
  margin: 0;
  min-width: 0;
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
`

export const PreviousPlanBadge = styled.span`
  position: absolute;
  top: 8px;
  right: 8px;
  padding: 2px 8px;
  border-radius: 10px;
  background-color: #e6e6e6;
  border: 1px solid #bfbfbf;
  font-size: 9px;
  font-weight: 600;
  color: #595959;
  text-transform: uppercase;
  letter-spacing: 0.4px;
  line-height: 1.4;
  white-space: nowrap;
`

export const ViewLink = styled.button`
  display: inline-flex;
  align-items: center;
  gap: 3px;
  font-size: 11px;
  font-weight: 500;
  color: ${({ theme }) => theme.colors.primary};
  background: none;
  border: none;
  padding: 3px 0;
  cursor: pointer;
  transition: color 150ms ease-out;
  white-space: nowrap;
  flex-shrink: 0;

  &:hover {
    color: ${({ theme }) => theme.colors.primary || '#0088b8'};
    text-decoration: underline;
  }

  &:focus {
    outline: 2px solid ${({ theme }) => theme.colors.primary};
    outline-offset: 2px;
    border-radius: 2px;
  }

  /* Mobile: 44px touch target */
  @media (max-width: 640px) {
    min-height: 44px;
    padding: 8px 0;
  }

  @media (hover: none) {
    &:hover {
      text-decoration: none;
    }

    &:active {
      text-decoration: underline;
    }
  }
`
